import { Button, Card, Spinner } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import showToast from '../../../components/CustomToast/toastHelper'
import client from '../../../api/client'
import CustomModal from '../../../components/Modal/CustomModal'
import PaymentSummaryModal from '../PaymentSummaryModal/PaymentSummaryModal'
import ValidatePaymentModal from '../ValidatePaymentModal/ValidatePaymentModal'
import { AirtimePurchaseProps } from '../AirtimePurchase/AirtimePurchase'

const DataPurchase = ({ hasPin, triggerPinSetup }: AirtimePurchaseProps) => {
    const [providers, setProviders] = useState<any>([])
    const [packages, setPackages] = useState<any>([])
    const [selectedProvider, setSelectedProvider] = useState<number | null>(null);
    const [activeProvider, setActiveProvider] = useState<string>('')
    const [selectedPackage, setSelectedPackage] = useState<any>()
    const [amount, setAmount] = useState(0)
    const [phoneNumber, setPhoneNumber] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [allGood, setAllGood] = useState<boolean>(false)
    const [categoryId, setCategoryId] = useState<number>(0)
    const [transactionId, setTransactionId] = useState<any>(1)
    const [openSummaryModal, setOpenSummaryModal] = useState<boolean>(false)
    const [openValidationModal, setOpenValidationModal] = useState<boolean>(false)
    const [payload, setPayload] = useState<any>(null)


    const handleClick = () => {
        const canProceed = triggerPinSetup();
        console.log(canProceed);

        if (canProceed) {
            setOpenValidationModal(true)
        } else {
            console.log("PIN setup required!");
        }
    };
    const validateInputs = () => {
        if (selectedProvider == null || phoneNumber == '' || amount == 0 || selectedPackage == null) {
            setAllGood(false)
        }
        else {
            setAllGood(true)
        }
    }
    const getProviders = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/bills-payment/data/providers/get');
            console.log(response);

            setProviders(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };


    const getPackages = async (providerSlug: string) => {
        try {
            const response = await client.get(`/subsidiary/dashboard/bills-payment/biller/${providerSlug}/packages/get`);
            console.log(response);
            const data = response.data.data
            const filteredPackages = data.filter((item: any) =>
                !/recharge|vtu/i.test(item.name)
            );
            setPackages(filteredPackages);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const handleProviderChange = (providerSlug: string) => {
        console.log(providerSlug);
        let providerDetails = providers.find((x: any) => x.slug == providerSlug)
        console.log(providerDetails);

        setActiveProvider(providerDetails.slug)
        setCategoryId(providerDetails.billerCategoryId)
        setSelectedProvider(providerDetails.id);
        setPackages([]);
        setAmount(0)
        getPackages(providerSlug);
    };

    const handlePackageChange = (item: any) => {
        console.log(item)
        let details = packages.find((x: any) => x.slug == item)
        console.log(details)
        setAmount(details.amount)
        setSelectedPackage(item)
    }

    // const initiatePurchase = async () => {
    //     setLoading(true)
    //     const payload = {
    //         customerId: phoneNumber,
    //         billerSlug: activeProvider,
    //         amount: amount,
    //         productName: selectedPackage,
    //         billCategoryId: categoryId
    //     }
    //     console.log(payload);

    //     try {
    //         const response = await client.post(`/subsidiary/dashboard/bills-payment/process-payment`, payload);
    //         console.log(response.data);
    //         showToast(response.data.message, "success")
    //         setProviders([])
    //         setAmount(0)
    //         setPackages([])
    //         setPhoneNumber('')
    //         setTransactionId(response.data.data.id)
    //         setOpenSummaryModal(true)

    //     } catch (err: any) {
    //         if (err?.response?.data?.message === 'Please login again') {
    //             sessionStorage.clear();
    //             window.location.href = '/';
    //         } else {
    //             const message = err?.response?.data?.message;
    //             console.error('error getting data', err);
    //             showToast(message, "error");
    //         }
    //     }
    //     finally {
    //         setLoading(false)
    //     }
    // };

    useEffect(() => {
        const fetchData = async () => {
            await getProviders()
        }
        fetchData()
    }, [])

    const constructPayload = () => {
        const payload = {
            customerId: phoneNumber,
            billerSlug: activeProvider,
            amount: amount,
            productName: selectedPackage,
            billCategoryId: categoryId
        }
        setPayload(payload)
    }


    useEffect(() => {
        validateInputs()
        constructPayload()
    }, [selectedProvider, amount, phoneNumber, selectedPackage])

    return (
        <div className='grid grid-cols-1 md:grid-cols-3'>
            <div>
                <p className='text-xl font-semibold'>Data Purchase</p>
                <p className='text-xs'>Enter your details to purchase your data</p>
            </div>
            <div className='md:col-span-2 mr-8'>
                <Card className='shadow-none'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <CustomSelectInput label='Service Provider' items={providers} displayKey='name' valueKey='slug' onChange={(providerSlug: any) => handleProviderChange(providerSlug)} />
                        <CustomSelectInput label='Select Package' items={packages} displayKey='name' valueKey='slug' onChange={(item: any) => handlePackageChange(item)} />
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <CustomInput label='Phone Number' name='phoneNumber' value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                        {amount != 0 && (
                            <div>
                                <CustomInput label='Amount' type='number' name='amount' value={amount} readonly />
                            </div>
                        )}
                    </div>

                    <div className='flex justify-end '>
                        <Button className='w-full md:w-2/6 rounded-sm bg-custom-button-green text-black hover:text-white' disabled={allGood == false} onClick={() => handleClick()}>{loading ? <Spinner size='sm' /> : 'Buy Data'}</Button>
                    </div>
                </Card>
            </div>
            <CustomModal show={openValidationModal} icon='' dismissible onClose={() => setOpenValidationModal(false)} size='md'>
                <ValidatePaymentModal payload={payload} closeVerificationModal={() => setOpenValidationModal(false)} />
            </CustomModal>
        </div>
    )
}

export default DataPurchase
